import React from "react";
import { useTranslation } from "react-i18next";
import { LoadingContainer } from "go-core/components/Loading";
import { ReactComponent as LogoSVG } from "../../../../../../images/svg/public/numberSystem/logo.svg";
import { OrderPreparationStatusName } from "../../../../../../services/Api/Organization/types";
import { NumberOrderApi, NumberOrderOrganizationInfoApi } from "../../../../../../services/Api/Public/types";
import { getNumberSystemFilteredItemsByStatuses } from "../../utils";
import NumberSystemCompanyInfo from "./NumberSystemCompanyInfo";
import NumberSystemSectionMobile from "./NumberSystemSectionMobile";

interface Props {
	items: NumberOrderApi[];
	itemsLoading: boolean;
	organizationInfo: NumberOrderOrganizationInfoApi | undefined;
	showItems: boolean;
}

const NumberSystemMobileContainer = ({ items, itemsLoading, organizationInfo, showItems }: Props) => {
	const { t } = useTranslation();

	return (
		<div className="p-3 d-flex flex-column number-system-mobile-container">
			<NumberSystemCompanyInfo organizationInfo={organizationInfo} />
			<div className="d-flex gap-3 sections">
				{itemsLoading ? (
					<LoadingContainer />
				) : (
					showItems && (
						<>
							<NumberSystemSectionMobile
								title={t("modules.order.field.in_progress.title")}
								items={getNumberSystemFilteredItemsByStatuses(items, [
									OrderPreparationStatusName.IN_PROGRESS,
									OrderPreparationStatusName.READY,
									OrderPreparationStatusName.NEW,
								])}
							/>
							<NumberSystemSectionMobile
								title={t("enums.preparation_statuses.READY")}
								items={getNumberSystemFilteredItemsByStatuses(items, [
									OrderPreparationStatusName.PACKED,
								])}
							/>
						</>
					)
				)}
			</div>
			<div className="d-flex align-items-end justify-content-center logo-container mt-auto">
				<LogoSVG className="logo" />
			</div>
		</div>
	);
};

export default NumberSystemMobileContainer;
